export default __webpack_public_path__ + "static/2023-resume-e269a84db5da357f90139b39e76b0793.pdf";